/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchWithLabelVComponent } from './switch-with-label-v.component';

@NgModule({
  declarations: [SwitchWithLabelVComponent],
  imports: [CommonModule],
  exports: [SwitchWithLabelVComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SwitchWithLabelVModule {}
